module.exports = __webpack_public_path__ + "static/media/photoicon.20d486fa.svg";